// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbnail-page-wrapper {
  display: flex;
  flex-direction: column;
  padding: 10px;

  background: white;
  /* border: 1px solid #404040; */
  /* box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
    0 15px 35px rgba(50, 50, 93, 0.3), 0 5px 15px rgba(0, 0, 0, 0.1); */

  margin: 15px;
  min-width: 245px;
  min-height: 245px;
  border: 1px solid #939393;
  border-radius: 5px;

  transition: all 0.1s ease-in-out;
}

.thumbnail-page-wrapper:empty {
  height: 320px;
  width: 245px;
  background-image:
    radial-gradient(circle at right top, white -100%, black),
    linear-gradient(grey, grey), linear-gradient(white, white);
  background-size:
    225px 250px,
    225px 30px,
    100% 100%;
  background-position:
    10px 20px,
    10px 280px,
    0 0;
  background-repeat: no-repeat;
}

.thumbnail-page-wrapper:hover {
  transform: scale(1.05);
}

.thumbnail-wrapper {
  width: 90%;
}

.thumbnail-img {
  object-fit: contain;
  height: 200px;
  width: 100%;
  margin: 0;
  border-radius: 5px;
}

.thumbnail-matrix .thumbnail-img,
.project-section__thumbnail-carosel .thumbnail-img {
  object-fit: cover;
}

.thumbnail-title {
  margin: 0px;
}

.thumbnail__short-desc {
  color: #404040;
}

.thumbnail__tech-stack {
  font-size: 14px;
  color: #404040;
}

.fade {
  /* opacity: 0; */
  transition: all 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/thumbnail/thumbnail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;;EAEb,iBAAiB;EACjB,+BAA+B;EAC/B;uEACqE;;EAErE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;;EAElB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ;;8DAE4D;EAC5D;;;aAGW;EACX;;;OAGK;EACL,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".thumbnail-page-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n\n  background: white;\n  /* border: 1px solid #404040; */\n  /* box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),\n    0 15px 35px rgba(50, 50, 93, 0.3), 0 5px 15px rgba(0, 0, 0, 0.1); */\n\n  margin: 15px;\n  min-width: 245px;\n  min-height: 245px;\n  border: 1px solid #939393;\n  border-radius: 5px;\n\n  transition: all 0.1s ease-in-out;\n}\n\n.thumbnail-page-wrapper:empty {\n  height: 320px;\n  width: 245px;\n  background-image:\n    radial-gradient(circle at right top, white -100%, black),\n    linear-gradient(grey, grey), linear-gradient(white, white);\n  background-size:\n    225px 250px,\n    225px 30px,\n    100% 100%;\n  background-position:\n    10px 20px,\n    10px 280px,\n    0 0;\n  background-repeat: no-repeat;\n}\n\n.thumbnail-page-wrapper:hover {\n  transform: scale(1.05);\n}\n\n.thumbnail-wrapper {\n  width: 90%;\n}\n\n.thumbnail-img {\n  object-fit: contain;\n  height: 200px;\n  width: 100%;\n  margin: 0;\n  border-radius: 5px;\n}\n\n.thumbnail-matrix .thumbnail-img,\n.project-section__thumbnail-carosel .thumbnail-img {\n  object-fit: cover;\n}\n\n.thumbnail-title {\n  margin: 0px;\n}\n\n.thumbnail__short-desc {\n  color: #404040;\n}\n\n.thumbnail__tech-stack {\n  font-size: 14px;\n  color: #404040;\n}\n\n.fade {\n  /* opacity: 0; */\n  transition: all 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
